import axios from 'axios';
import { BASE_URL, API_BASE_URL } from '../config';


const axiosInstance = axios.create({ baseURL: BASE_URL });

// API axios instance for API calls
export const apiAxios = axios.create({ baseURL: API_BASE_URL });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

apiAxios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
